<template>
  <main id='Story' :class='{center: transcript==false}' v-if='kirby.page.template == "story"' v-scroll-lock='true'>
    <div class='overlay' :class='{phone: size=="phone"}'>
      <header>
        <h1 class="title" v-html='kirby.page.strings.title' />
        <nav>
          <sharethisstory v-if='!kiosk' :url='kirby.page.url'/>
          <close />
        </nav>
      </header>

      <section class='story'>
        <section class='interactive'>
          <div>
            <player v-if='firstOfArrayOrString(kirby.page.strings.story_audio)' :audio='kirby.page.files[firstOfArrayOrString(kirby.page.strings.story_audio)].src'>
            <h3 v-html='kirby.page.strings.author' />
            <time class='date' v-if='kirby.page' v-html='formattedDate(kirby.page.strings.date, "mmmm d, yyyy")' />
            </player>
          </div>
          <footer>
            <summary v-if='kiosk && kirby.pages.stories.content.kioskdescription' class="kiosk description" v-html='kirby.pages.stories.content.kioskdescription.kirbytext' />
            <details v-if='!kiosk' v-for='(detail, index) in yaml(kirby.site.strings.details)' :open='current==index ? "true" : null '>
              <summary @click.prevent.self='current=index' v-html='detail.title' />
              <section v-html='detail.disclaimer' />
            </details>
            <tags class='tags' :tags='kirby.page.strings.story_tags.split(/,\s*/)' @selectTag='clickTag($event)'/>
          </footer>
        </section>
        <article :class='{transcript: true, phone: size=="phone"}'>
          <h4 class="title">Transcript</h4>
          <div :class='{hidden: transcript==false}' v-html='kirby.page.content.transcript.kirbytext' />
          <button @click='transcript=!transcript' v-html='transcript==false ? "Show" : "Hide"' />
        </article>
      </section>
    </div>
  </main>
</template>


<script>
import mixins from '.././mixins.js';
import Vue from 'vue';
import VScrollLock from 'v-scroll-lock';
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock'

Vue.use(VScrollLock, {
  bodyScrollOptions: {
    reserveScrollBarGap: true,
  },
  enableBodyScroll,
  disableBodyScroll,
})

export default {
  mixins: [mixins],
  data: function() {
    return {
      current: 0,
      transcript: false
    }
  },
  mounted: function(){
    this.$emit("addReasonToShowVeil");
  },
  destroyed: function(){
    this.$emit("removeReasonToShowVeil");
  },
  methods: {
    clickTag: function(tag){
      let url = './'+this.pageFromURI(this.kirby.page.parent).uri+'#'+tag.replaceAll(' ', '_').replace('&', 'ambersand');
      window.location.href = url;
    },
    track: function() {
      this.$gtag.screenview({
        app_name: 'Listening Lab Kiosk',
        screen_name: 'Story Page',
      })
    }
  }
}
</script>

<style scoped>

  main {
    margin: auto;
    position: fixed;
    overflow-y: scroll;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    -webkit-overflow-scrolling: touch;
  }


  main.center {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  main:not(.center) {
    padding-bottom: 4rem;
  }

  div.overlay {
    max-width: var(--main-max-width);
    background-color: var(--lightmint);
    /*min-height: 47rem;*/
    width: calc(100% - 2rem);
    box-sizing: border-box;
    padding: var(--overlaypadding);
    border-radius: 2rem;
    left: 0;
    right: 0;
    position: absolute;
    margin: var(--overlaymargin);
  }

  div.overlay.phone {
    top: 0;
  }

  header {
    width: 100%;
    display: flex;
    flex-direction: var(--columns-or-rows);
    justify-content: space-between;
    margin-bottom: 4em;
    gap: 3em;
  }

  header h1 {
    flex-grow: 1;
    flex-basis: 0;
    margin: 0;
    font-weight: lighter;
  }

  header > nav {
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    gap: 1em;
    align-items: center;
  }

  nav.tags {
    margin-bottom: 0;
  }

  section.story {
    /*position: absolute;
    top: 14em;
    left: 4em;
    right: 4em;
    bottom: 4em;*/
    display: flex;
    flex-direction: var(--columns-or-rows);
    gap: 3em;
  }

  section.interactive {
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  footer {
    margin-top: 3rem;
  }

  h3 {
    font-weight: lighter;
    margin-top: 0.5em;
    font-size: 1.5em;
    letter-spacing: 0;
    margin-bottom: 0.25em;
  }

  article.transcript {
    flex-grow: 1;
    flex-basis: 0;
    margin-top: -0.5em;
    padding: 3.5em 1em 0em 0.125em;
    box-sizing: border-box;
    position: relative;
    display: block;
  }

  article:not(.phone) div {
    text-align: left;
    transition: height 0.5s ease-in-out;
    position: relative;
  }

  article:not(.phone) div.hidden::after {
    content: '';
    position: absolute;
    bottom: 0;
    height: 10rem;
    width: 100%;
    background: linear-gradient(to top, rgba(243, 249, 245, 0.9) 0%, rgba(243, 249, 245, 0.4) 50%, rgba(243, 249, 245, 0) 100%);
    display: block;
  }

  article:not(.phone) div.hidden {
    max-height: 20rem;
    overflow-y: hidden;
    scroll-behavior: smooth;
  }

  article:not(.phone) div:not(.hidden) {
    max-height: auto;
  }

  article:not(.phone) {
    text-align: center;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  article:not(.phone) button {
    margin-top: 1rem;
    min-width: 10em;
  }

  article.phone button {
    display: none;
  }

  article h4.title {
    text-transform: uppercase;
    width: 100%;
    text-align: left;
    margin-top: 0;
    margin-bottom: 0rem;
    top: -3rem;
    position: relative;
  }


  article {
    position: absolute;
    /* scrollbar-color: var(--darkmint) var(--darkmint);
    -webkit-overflow-scrolling: touch;
    -webkit-transform: translateZ(0);*/
  }

  article::-webkit-scrollbar {
    /*width: 0.3rem;*/
  }

  article::-webkit-scrollbar-thumb {
    /*background-color: var(--darkmint);*/
    /*border-radius: 0;*/
  }


   details summary {
     cursor: pointer;
     font-size: 1.125em;
     margin-bottom: 0.75em;
   }

   details {
     margin-bottom: 0.5em;
   }

   details:last-of-type {
     margin-bottom: 2em;
   }

   details section {
     padding-left: 1.5em;
     font-size: 0.9em;
     line-height: 1.25em;
     margin-bottom: 1.5em;
     letter-spacing: -.001em;
   }

   .kiosk.description {
     margin-bottom: 2em;
     padding-right: 4em;
   }

</style>

<style>
   details section p + p {
     margin-top: 0.66em;
   }
</style>
